<div class="empty-solution">
  <div class="empty-solution__container">
    <img class="empty-solution__image" [src]="illustration" />
    <div class="">
      <h2 nz-typography>{{ headline }}</h2>

      <ng-content></ng-content>

      <strong nz-typography *ngIf="demos">
        @if (demoLink || downloadDemo) {
          {{ 'Want to know how it works?' | translate: { _key: 'shared.empty-solution.subheader-with-demo-link' } }}
        } @else {
          {{
            'Meanwhile, master analysing battery analytics?'
              | translate: { _key: 'shared.empty-solution.subheader-without-demo-link' }
          }}
        }
      </strong>

      @if (demos) {
        <div class="empty-solution__buttons">
          @if (!downloadDemo) {
            <a class="text-sm" [href]="BATTERY_ENCYCLOPEDIA_LINK" target="_blank" rel="noopener noreferrer">
              {{ 'Open Battery Encyclopedia' | translate: { _key: 'shared.empty-solution.encyclopedia-link-label' } }}
            </a>
          }
          @if (demoLink) {
            <button nz-button nzType="primary" [twDemoLink]="demoLink">
              {{ 'View Demo' | translate: { _key: 'shared.empty-solution.demo-button-label' } }}
            </button>
          }
          @if (downloadDemo) {
            <a class="text-sm" [href]="DEMO_DOWNLOAD_LINK" target="_blank" rel="noopener noreferrer">
              {{ 'Download Demo Model' | translate: { _key: 'shared.empty-solution.download-demo-button-label' } }}
            </a>
          }
          <ng-content select="button,a"></ng-content>
        </div>
      }
    </div>
  </div>
</div>
